import { decryptString, encryptString } from "./EncryptDecryptData";

// output is url friendly because it will be used in the url
const encodeQueryParams = async (queryParamsText) => {
  const encryptedString = encryptString(queryParamsText);
  return encodeURIComponent(encryptedString);
};

const decodeQueryParams = async (queryParamsText) => {
  const encryptedString = decodeURIComponent(queryParamsText);
  return decryptString(encryptedString);
};

const decodeQueryParamsToObject = ({ filterText, configFilters }) => {
  const filterArr = filterText.split(";");
  const resultMap = {};
  let resultText = "";
  for (const configSingle of configFilters) {
    const field = configSingle.field;
    const type = configSingle.type;
    const alias = configSingle.alias;

    let foundFilters;
    switch (type) {
      case "date_range":
        foundFilters = filterArr.filter((el) => el.includes(field));

        if (foundFilters && foundFilters.length > 0) {
          const gtFilter = foundFilters.find((el) => el.includes(":>=:"));
          const ltFilter = foundFilters.find((el) => el.includes(":<=:"));
          let gtValue = gtFilter ? gtFilter.split(":>=:")[1] : null;
          let ltValue = ltFilter ? ltFilter.split(":<=:")[1] : null;
          if (gtValue.includes("||")) {
            gtValue = gtValue.split("||")[0];
          }
          if (ltValue.includes("||")) {
            ltValue = ltValue.split("||")[0];
          }
          if (gtValue && ltValue) {
            resultText += `${
              resultText.length > 0 ? ";" : ""
            }${gtFilter};${ltFilter}`;
            resultMap[alias ?? field] = [new Date(gtValue), new Date(ltValue)];
          }
        }
        break;
      case "object":
        foundFilters = filterArr.filter((el) => el.includes(field));
        // const objectArr = foundFilters.split("|||");
        if (foundFilters && foundFilters.length > 0) {
          const singleFoundFilter = foundFilters[0];
          const objectArr = singleFoundFilter.split("|||");
          let filterText = "";
          let filterObjectText;
          let filterObject;
          if (objectArr.length > 0) filterText = objectArr[0];
          if (objectArr.length > 1)
            filterObjectText = objectArr[1].replaceAll(`${field}=`, "");
          if (filterObjectText) filterObject = JSON.parse(filterObjectText);
          if (filterText && filterObject) {
            resultMap[alias ?? field] = filterObject;
            resultText += `${resultText.length > 0 ? ";" : ""}${filterText}`;
          }
        }
        break;
    }
  }
  return { filterText: resultText, filterObject: resultMap };
};

export { encodeQueryParams, decodeQueryParams, decodeQueryParamsToObject };
